import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import PaidInvoiceWorkflow from "Components/Endcustomerpaid/Workflows/PaidInvoiceWorkflow";
import { EndCustomerPaidContextProvider } from "Context/EndCustomerPaid";
import BookButton from "./components/BookButton";
import EndCustomerPaidMatchingTable from "./components/EndCustomerPaidMatchingTable";
import InvoiceInfoBox from "./components/InvoiceInfoBox";
import BundleSelect from "./components/BundleSelect";
import DeleteBundleButton from "./components/DeleteBundleButton";

export function EndCustomerPaidMatching() {
  return (
    <EndCustomerPaidContextProvider>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item container xs={12} md={12}>
            <Grid
              item
              container
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "1.0rem",
              }}
            >
              <Grid item container>
                <Grid item>
                  <Typography variant="h5">
                    Slutkundsinbetalningar matchning
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      minWidth: "320px",
                    }}
                  >
                    <BundleSelect />
                    <DeleteBundleButton />
                  </Box>
                </Grid>

                <Grid item ml={5}>
                  <InvoiceInfoBox />
                </Grid>
              </Grid>
            </Grid>
            <EndCustomerPaidMatchingTable />
            <BookButton />
            <PaidInvoiceWorkflow />
          </Grid>
        </Grid>
      </Box>
    </EndCustomerPaidContextProvider>
  );
}
